import { render } from "./Receivemessages.vue?vue&type=template&id=4c5e4a44"
import script from "./Receivemessages.vue?vue&type=script&lang=js"
export * from "./Receivemessages.vue?vue&type=script&lang=js"

import "./Receivemessages.vue?vue&type=style&index=0&id=4c5e4a44&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__